import React from "react";
import "../theme/AdministracionCatalogo.css";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { TableAdministracionCatalogo } from "../components/TableAdministracionCatalogo";
import { authProvider } from "../context/authProvider";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";

export const AdminPageCatalogo = () => {
  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div className="body-color-admin">
              <div className="title-name-admin">
                <BtnGoBack caption="Volver a administración" />
              </div>
              <TableAdministracionCatalogo />
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
